export const types = {
  CLOSE: 'contacts/accountDetails/contactsDrawer/CLOSE',
  OPEN: 'contacts/accountDetails/contactsDrawer/OPEN',
};

export const contactsDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: () => ({
    type: types.OPEN,
  }),
};
